(function () {
  'use strict';

  if (window.LoomCoffeeCards) {
    window.LoomCoffeeCards.refresh();
    return;
  }

  const groupSelector = '.products-slider, [data-product-list]';
  const cardSelector = '.thumbnail.thumbnail-hover-enabled--false:has(.product-info__caption .product-details--coffee)';
  const heightProperty = '--loom-coffee-card-height';
  const groups = new Map();
  let pending = 0;
  let mutations = null;
  let observedBody = null;

  function dispose(group, state) {
    if (state.observer) state.observer.disconnect();
    group.style.removeProperty(heightProperty);
    group.classList.remove('loom-cards-equalized');
    groups.delete(group);
  }

  function equalize(group, state) {
    if (!group.isConnected || !state.cards.length) return;
    group.style.removeProperty(heightProperty);
    const height = Math.ceil(Math.max(...state.cards.map(card => card.getBoundingClientRect().height)));
    if (!height) return;
    group.style.setProperty(heightProperty, height + 'px');
    if (height !== state.height) {
      state.height = height;
      const jquery = window.jQuery;
      if (group.classList.contains('flickity-enabled') && jquery && jquery.fn.flickity) {
        jquery(group).flickity('resize');
      }
    }
  }

  function refresh() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = 0;
      if (mutations && observedBody !== document.body) {
        mutations.disconnect();
        observedBody = document.body;
        if (observedBody) mutations.observe(observedBody, { childList: true, subtree: true });
      }
      groups.forEach((state, group) => {
        if (!group.isConnected) dispose(group, state);
      });
      document.querySelectorAll(groupSelector).forEach(group => {
        const cards = Array.from(group.querySelectorAll(cardSelector)).filter(card => card.closest(groupSelector) === group);
        let state = groups.get(group);
        if (!cards.length) {
          if (state) dispose(group, state);
          return;
        }
        if (!state) {
          state = { cards: [], height: 0, width: 0, observer: null };
          groups.set(group, state);
        }
        if (cards.length !== state.cards.length || cards.some((card, index) => card !== state.cards[index])) {
          if (state.observer) state.observer.disconnect();
          state.cards = cards;
          if (window.ResizeObserver) {
            state.observer = new window.ResizeObserver(entries => {
              const changed = entries.some(entry => {
                if (entry.target !== group) return true;
                const width = entry.contentRect.width;
                if (width === state.width) return false;
                state.width = width;
                return true;
              });
              if (changed) refresh();
            });
            state.observer.observe(group);
            cards.forEach(card => {
              card.querySelectorAll('.product_image, .loom-card__body, .loom-card__rating, .inline-quickshop').forEach(element => state.observer.observe(element));
            });
          }
        }
        group.classList.add('loom-cards-equalized');
        equalize(group, state);
      });
    });
  }

  function unload(root) {
    groups.forEach((state, group) => {
      if (root === group || root.contains(group)) dispose(group, state);
    });
  }

  window.LoomCoffeeCards = { refresh, unload };

  function boot() {
    refresh();
    mutations = new window.MutationObserver(records => {
      const relevant = records.some(record => {
        if (record.target.closest && record.target.closest(groupSelector)) return true;
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node =>
          node.nodeType === 1 && (node.matches(groupSelector) || node.querySelector(groupSelector))
        );
      });
      if (relevant) refresh();
    });
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', event => unload(event.target));
    document.addEventListener('load', event => {
      if (event.target.matches && event.target.matches('img') && event.target.closest(groupSelector)) refresh();
    }, true);
    window.addEventListener('resize', refresh, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    if (window.InstantClick && window.InstantClick.on) window.InstantClick.on('change', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
